export const SET_COMMUNICATION_MODULE_MASTERS = 'SET_COMMUNICATION_MODULE_MASTERS'
export const SET_MODAL_STATE = 'SET_MODAL_STATE'
export const UPDATE_MODAL_DISPLAY_STATE_REPORT_ENGINE = 'UPDATE_MODAL_DISPLAY_STATE_REPORT_ENGINE'
export const UPDATE_COMMUNICATION_MODULE_PARAMS = 'UPDATE_COMMUNICATION_MODULE_PARAMS'
export const RESET_COMMUNICATION_MODULE_PARAMS = 'RESET_COMMUNICATION_MODULE_PARAMS'
export const UPDATE_COMMUNICATION_SEARCH_RESULT = 'UPDATE_COMMUNICATION_SEARCH_RESULT'
export const SET_CREATE_LINK_PARAMS = 'SET_CREATE_LINK_PARAMS'
export const RESET_CREATE_LINK_PARAMS = 'RESET_CREATE_LINK_PARAMS'
export const GET_CURRENT_MASTER_COMM_END = 'GET_CURRENT_MASTER_COMM_END'
export const UPDATE_COMMUNICATION_DOCUMENT_PARAMS = 'UPDATE_COMMUNICATION_DOCUMENT_PARAMS'
export const ADD_NEW_COMMUNICATION_DOCUMENT = 'ADD_NEW_COMMUNICATION_DOCUMENT'
export const UPDATE_COMMUNICATION_DOCUMENT_DOCUMENT_PARAMS = 'UPDATE_COMMUNICATION_DOCUMENT_DOCUMENT_PARAMS'
export const GET_COMMUNICATION_DOCUMENTS_END = 'GET_COMMUNICATION_DOCUMENTS_END'
export const RESET_COMMUNICATION_MODULE_MASTER_PARAMS = 'RESET_COMMUNICATION_MODULE_MASTER_PARAMS'
export const RESET_COMMUNICATION_TASK_ASSIGNMENT = 'RESET_COMMUNICATION_TASK_ASSIGNMENT'
export const SET_COMMUNICATION_TASK_ASSIGN_ENTRY_PARAMS = 'SET_COMMUNICATION_TASK_ASSIGN_ENTRY_PARAMS'
export const GET_COMMUNICATIONS_LOG_END = 'GET_COMMUNICATIONS_LOG_END'
export const ON_CHANGE_USER_OTP_PARAMS = 'ON_CHANGE_USER_OTP_PARAMS'
export const GET_CURRENT_MASTER_COMM_FOR_USER_ENTRY_END = 'GET_CURRENT_MASTER_COMM_FOR_USER_ENTRY_END'
export const ON_CHANGE_USER_DETAILS_PARAMS = 'ON_CHANGE_USER_DETAILS_PARAMS'
export const RESET_COMMUNICATION_MODULE_PARAMS_EXCEPT_SEARCH = 'RESET_COMMUNICATION_MODULE_PARAMS_EXCEPT_SEARCH'

export const UPDATE_DOCUMENTS_LIST_ON_FRONT = 'UPDATE_DOCUMENTS_LIST_ON_FRONT'
// Get Quote Online company website feature
export const GET_CURRENT_MASTER_COMM_FOR_GET_QUOTE_ONLINE_END = 'GET_CURRENT_MASTER_COMM_FOR_GET_QUOTE_ONLINE_END';
export const ON_CHANGE_GET_QUOTE_ONLINE_DETAILS_PARAMS = 'ON_CHANGE_GET_QUOTE_ONLINE_DETAILS_PARAMS';
export const RESET_GET_QUOTE_ONLINE_MASTER_PARAMS = 'RESET_GET_QUOTE_ONLINE_MASTER_PARAMS';
export const UPDATE_GET_QUOTE_ONLINE_DOCUMENTS_LIST_ON_FRONT = 'UPDATE_GET_QUOTE_ONLINE_DOCUMENTS_LIST_ON_FRONT';
// Get Quote  Online Documents upload
export const UPDATE_GET_QUOTE_ONLINE_DOCUMENT_PARAMS = 'UPDATE_GET_QUOTE_ONLINE_DOCUMENT_PARAMS';
export const UPDATE_GET_QUOTE_ONLINE_DOCUMENT_DOCUMENT_PARAMS = 'UPDATE_GET_QUOTE_ONLINE_DOCUMENT_DOCUMENT_PARAMS';
export const ADD_NEW_GET_QUOTE_ONLINE_DOCUMENT = 'ADD_NEW_GET_QUOTE_ONLINE_DOCUMENT';

export const CONFIRM_NO = 'CONFIRM_NO';
export const CONFIRM_YES = 'CONFIRM_YES';
export const TOGGLE_CONFRIM_POPUP = 'TOGGLE_CONFRIM_POPUP';